import { getCssProperty } from "../../../assets/js/utils/utils";

const SELECTORS = {
  container: {
    default: "Grid-container",
    oneBigTwoSmall: "Grid-container--oneBigTwoSmall",
  },
  item: {
    default: "Grid-item",
    oneBigTwoSmall: "Grid-item--oneBigTwoSmall",
    contentContainer: "ContentPreview-contentContainer",
  },
  customProperty: "--Grid-container--oneBigTwoSmall-shouldResize",
};

/**
 * This class handles the oneBigTwoSmall variant where headlines
 * and images from the first (featured) and the third teaser have
 * to be aligned by pixel
 */
class Grid {
  /**
   * @param {HTMLElement} grid
   */
  constructor(grid) {
    this.grid = grid;
    this._setBindings();
    this._initializeGrid();
  }

  /**
   * Sets bindings for methods used in callbacks
   */
  _setBindings() {
    this._setContentContainerDimensions =
      this._setContentContainerDimensions.bind(this);
  }

  /**
   * Query all necessary elements and setup the ResizeObserver
   */
  _initializeGrid() {
    this._queryElements();
    this.observer = new ResizeObserver(
      this._setContentContainerDimensions
    ).observe(this.grid);
  }

  /**
   * Queries all necessary grid elements
   */
  _queryElements() {
    this.contentContainers = Array.from(
      this.grid.querySelectorAll(`.${SELECTORS.item.contentContainer}`)
    ).slice(0, 3);
    this.contentContainerToAdjust = Array.from(
      this.contentContainers.filter((container) => {
        return container.parentElement.classList.contains(
          SELECTORS.item.oneBigTwoSmall
        );
      })
    ).shift();
    this.contentContainerToAnalyze = this.contentContainers.pop();
  }

  /**
   * Checks if the customProperty for the grid is set
   *
   * @returns {boolean}
   */
  _checkIfActive() {
    return getCssProperty(this.grid, SELECTORS.customProperty).length > 0;
  }

  /**
   * Set the height of the featured teasers contentContainer
   */
  _setContentContainerDimensions() {
    if (this._checkIfActive()) {
      this.contentContainerToAdjust.style.height = `${
        this.contentContainerToAnalyze.getBoundingClientRect().height
      }px`;
    } else {
      this.contentContainerToAdjust.style.removeProperty("height");
    }
  }
}

export default Grid;
